export default __webpack_public_path__ + "static/Bg-uk-andriod-85b33ac46760610364deca3b594cab31.webp";